export const DashboardReport: DASHBOARDREPORTCONFIG = [
  {
    header: "Dashboard Details",
    description: "",
    order: 1,
    menus: [
      {
        icon: "",
        menu: "Vehicle Status",
        menu_description: "",
        url: "/api/vehicle/status",
        method: "GET",
        filters: [],
        columns: [
          // {
          //   uid: "date",
          //   name: "Date"
          // },
          {
            uid: "instituteName",
            name: "Institute"
          },
          {
            uid: "vehicleName",
            name: "Vehicle"
          },
          {
            uid: "vehicleStatus",
            name: "Vehicle Status"
          },
          {
            uid: "hardwareStatus",
            name: "Hardware Status"
          },
          {
            uid: "lastContactTime",
            name: "Last Contact Time"
          }
        ],
        activeColumns: [
          // "date",
          "instituteName",
          "vehicleName",
          "vehicleStatus",
          "hardwareStatus",
          "lastContactTime"
        ]
      },
      {
        icon: "",
        menu: "Trip Status",
        menu_description: "",
        url: "/api/trip/status/detail",
        method: "GET",
        filters: ["singleDate"],
        innerFilters: [
          {
            uid: "type",
            label: "Trip Type",
            type: "multiSelect",
            options: [
              {id: 0, name: "Pickup"},
              {id: 1, name: "Drop"}
            ],
            defaultValue: [0, 1]
          },
          {
            uid: "status",
            label: "Trip Status",
            type: "multiSelect",
            options: [
              {id: 1, name: "Yet to start"},
              {id: 2, name: "In progress"},
              {id: 3, name: "Completed"},
              {id: 4, name: "Not completed"}
            ],
            defaultValue: [1, 2, 3, 4]
          }
          // {
          //   uid: "userType",
          //   label: "User Type",
          //   type: "switch",
          //   options: [{id: 1, name: "Students"}],
          //   defaultValue: [1]
          // }
        ],
        columns: [
          {
            uid: "date",
            name: "Date"
          },
          {
            uid: "instituteName",
            name: "Institute"
          },
          {
            uid: "vehicleName",
            name: "Vehicle"
          },
          {
            uid: "tripName",
            name: "Route"
          },
          {
            uid: "tripType",
            name: "Trip Type"
          },
          {
            uid: "tripStartTime",
            name: "Start Time"
          },
          {
            uid: "tripEndTime",
            name: "End Time"
          },
          {
            uid: "tripStatus",
            name: "Status"
          }
        ],
        activeColumns: [
          "date",
          "vehicleName",
          "tripName",
          "tripType",
          "tripStatus"
        ],
        sideBar: [
          {
            type: "card",
            api_url: "/api/trip/status/summary",
            menu: "tripStatus",
            sidebarHeading: ""
          }
        ]
        // tabView: [
        //   {
        //     label: "All",
        //     id: ""
        //   },
        //   {
        //     label: "Yet to Start",
        //     id: 1
        //   },
        //   {
        //     label: "In Progress",
        //     id: 2
        //   },
        //   {
        //     label: "Completed",
        //     id: 3
        //   },
        //   {
        //     label: "Not Completed",
        //     id: 4
        //   }
        // ]
      },
      {
        icon: "",
        menu: "Speed Deviation",
        menu_description: "",
        url: "/api/deviation/speed/detail",
        method: "GET",
        filters: ["date"],
        columns: [
          {
            uid: "vehicleName",
            name: "Vehicle"
          },
          {
            uid: "deviationTime",
            name: "Deviation Time"
          },
          {
            uid: "speed",
            name: "Speed"
          },
          {
            uid: "threshold",
            name: "Threshold (Km)"
          }
        ],
        activeColumns: ["vehicleName", "deviationTime", "speed", "threshold"],
        sideBar: [
          {
            type: "card",
            api_url: "/api/deviation/speed",
            menu: "speedDeviation",
            sidebarHeading: ""
          }
        ]
      },
      {
        icon: "",
        menu: "Distance Driven",
        menu_description: "",
        url: "/api/distance/driven/detail",
        method: "GET",
        filters: ["date"],
        columns: [
          {
            uid: "date",
            name: "Date"
          },
          {
            uid: "instituteName",
            name: "Institute Name"
          },
          {
            uid: "trackerId",
            name: "Tracker Id"
          },
          {
            uid: "vehicleName",
            name: "Vehicle"
          },
          {
            uid: "scheduled",
            name: "Scheduled Kms"
          },
          {
            uid: "unScheduled",
            name: "Unscheduled Kms"
          }
        ],
        activeColumns: [
          "date",
          "instituteName",
          "trackerId",
          "vehicleName",
          "scheduled",
          "unScheduled"
        ]
        // sideBar: [
        //   {
        //     type: "card",
        //     api_url: "/api/distance/driven/summary",
        //     menu: "distanceDriven",
        //     sidebarHeading: ""
        //   }
        // ]
      },
      {
        icon: "",
        menu: "Distance Deviation",
        menu_description: "",
        url: "/api/deviation/distance/detail",
        method: "GET",
        filters: ["date"],
        //vehicleName,threshold
        columns: [
          {
            uid: "vehicleName",
            name: "Vehicle"
          },
          {
            uid: "deviationTime",
            name: "Deviation Time"
          },
          {
            uid: "totalDistance",
            name: "Distance"
          },
          {
            uid: "thresholdStr",
            name: "Threshold"
          }
        ],
        activeColumns: [
          "vehicleName",
          "deviationTime",
          "totalDistance",
          "thresholdStr"
        ],
        sideBar: [
          {
            type: "card",
            api_url: "/api/deviation/distance",
            menu: "distanceDeviation",
            sidebarHeading: ""
          }
        ]
      },
      {
        icon: "",
        menu: "Bus Attendance",
        menu_description: "",
        url: "/api/nextApi/attendanceReport/busAttendanceOverview",
        method: "GET",
        customView: "busAttendanceOverview",
        filters: ["date"],
        columns: [
          {
            uid: "date",
            name: "Date"
          },
          {
            uid: "instituteName",
            name: "Institute"
          },
          {
            uid: "name",
            name: "Name"
          },
          {
            uid: "className",
            name: "Class"
          },
          {
            uid: "enrollNo",
            name: "Enroll No"
          },
          {
            uid: "in_pick_time",
            name: "Pickup"
          },
          {
            uid: "out_drop_time",
            name: "Drop"
          },
          {
            uid: "other_swipes_time",
            name: "Other Swipes"
          },
          {
            uid: "attendanceStatus",
            name: "Status"
          }
        ],
        innerFilters: [
          {
            uid: "userType",
            label: "User Type",
            type: "multiSelect",
            options: [
              {id: 1, name: "User"},
              {id: 2, name: "Staff"}
            ],
            defaultValue: [1, 2]
          }
        ],
        activeColumns: [
          "date",
          "instituteName",
          "name",
          "className",
          "enrollNo",
          "in_pick_time",
          "out_drop_time",
          "other_swipes_time",
          "attendanceStatus"
        ]
      },
      {
        icon: "",
        menu: "Campus Attendance",
        menu_description: "",
        url: "/api/nextApi/attendanceReport/campusAttendanceOverview",
        method: "GET",
        customView: "campusAttendanceOverview",
        filters: ["date"],
        innerFilters: [
          {
            uid: "userType",
            label: "User Type",
            type: "multiSelect",
            options: [
              {id: 1, name: "User"},
              {id: 2, name: "Staff"}
            ],
            defaultValue: [1, 2]
          }
        ],
        columns: [
          {
            uid: "date",
            name: "Date"
          },
          {
            uid: "instituteName",
            name: "Institute"
          },
          {
            uid: "name",
            name: "Name"
          },
          {
            uid: "className",
            name: "Class"
          },
          {
            uid: "enrollNo",
            name: "Enroll No"
          },
          {
            uid: "in_pick_time",
            name: "In Time"
          },
          {
            uid: "out_drop_time",
            name: "Out Time"
          },
          {
            uid: "other_swipes_time",
            name: "Other Swipes"
          },
          {
            uid: "attendanceStatus",
            name: "Status"
          }
        ],
        activeColumns: [
          "date",
          "instituteName",
          "name",
          "className",
          "enrollNo",
          "in_pick_time",
          "out_drop_time",
          "other_swipes_time",
          "attendanceStatus"
        ]
      },
      {
        icon: "",
        menu: "Insurance Summary",
        menu_description: "",
        url: "api/insurance/summary",
        method: "GET",
        filters: [],
        columns: [
          {
            uid: "institutionName",
            name: "Institute"
          },
          {
            uid: "vehicleName",
            name: "Vehicle"
          },
          {
            uid: "regNo",
            name: "RegNo"
          },
          {
            uid: "validUpto",
            name: "Valid Upto"
          },
          {
            uid: "documentNumber",
            name: "Document Number"
          },
          {
            uid: "issuerName",
            name: "Issuer Name"
          },
          {
            uid: "status",
            name: "Status"
          },
          {
            uid: "updatedDtString",
            name: "Last Updated On"
          }
        ],
        activeColumns: [
          "institutionName",
          "vehicleName",
          "regNo",
          "validUpto",
          "documentNumber",
          "issuerName",
          "status",
          "updatedDt"
        ],
        tabView: [
          {
            label: "All",
            id: ""
          },
          {
            label: "Active Policies",
            id: 1
          },
          {
            label: "Expired Policies",
            id: 2
          },
          {
            label: "No Data",
            id: 3
          }
        ]
      },
      {
        icon: "",
        menu: "Permit Summary",
        menu_description: "",
        url: "api/permit/summary",
        method: "GET",
        filters: [],
        columns: [
          {
            uid: "institutionName",
            name: "Institute"
          },
          {
            uid: "vehicleName",
            name: "Vehicle"
          },
          {
            uid: "regNo",
            name: "RegNo"
          },
          {
            uid: "validUpto",
            name: "Valid Upto"
          },
          {
            uid: "documentNumber",
            name: "Document Number"
          },
          {
            uid: "issuerName",
            name: "Issuer Name"
          },
          {
            uid: "status",
            name: "Status"
          },
          {
            uid: "updatedDtString",
            name: "Last Updated On"
          }
        ],
        activeColumns: [
          "institutionName",
          "vehicleName",
          "regNo",
          "validUpto",
          "documentNumber",
          "issuerName",
          "status",
          "updatedDtString"
        ],
        tabView: [
          {
            label: "All",
            id: ""
          },
          {
            label: "Active Permits",
            id: 1
          },
          {
            label: "Expired Permits",
            id: 2
          },
          {
            label: "No Data",
            id: 3
          }
        ]
      },
      {
        icon: "",
        menu: "Pollution Summary",
        menu_description: "",
        url: "api/pollution/summary",
        method: "GET",
        filters: [],
        columns: [
          {
            uid: "institutionName",
            name: "Institute"
          },
          {
            uid: "vehicleName",
            name: "Vehicle"
          },
          {
            uid: "regNo",
            name: "RegNo"
          },
          {
            uid: "validUpto",
            name: "Valid Upto"
          },
          {
            uid: "documentNumber",
            name: "Document Number"
          },
          {
            uid: "status",
            name: "Status"
          },
          {
            uid: "updatedDtString",
            name: "Last Updated On"
          }
        ],
        activeColumns: [
          "institutionName",
          "vehicleName",
          "regNo",
          "validUpto",
          "documentNumber",
          "status",
          "updatedDtString"
        ],
        tabView: [
          {
            label: "All",
            id: ""
          },
          {
            label: "Active PC",
            id: 1
          },
          {
            label: "Expired PC",
            id: 2
          },
          {
            label: "No Data",
            id: 3
          }
        ]
      },
      {
        icon: "",
        menu: "Total Attendance",
        menu_description: "",
        url: "/api/allAttendance",
        method: "GET",
        filters: ["singleDate"],
        columns: [
          {
            uid: "date",
            name: "Date"
          },
          {
            uid: "instituteName",
            name: "Institute"
          },
          {
            uid: "name",
            name: "Name"
          },
          {
            uid: "className",
            name: "Class"
          },
          {
            uid: "enrollNo",
            name: "Enroll No"
          },
          // {
          //   uid: "in_pick_time",
          //   name: "Pickup"
          // },
          // {
          //   uid: "out_drop_time",
          //   name: "Drop"
          // },
          {
            uid: "attendance_status",
            name: "Status"
          }
        ],
        activeColumns: [
          "date",
          "instituteName",
          "name",
          "className",
          "enrollNo",
          "in_pick_time",
          "out_drop_time",
          "attendance_status"
        ]
      },
      {
        icon: "",
        menu: "Attendance Inconsistency Summary",
        menu_description: "",
        url: "api/attendance/inconsistency/detailView",
        method: "POST",
        filters: ["date"],
        columns: [
          {
            uid: "date",
            name: "Date"
          },
          {
            uid: "name",
            name: "Name"
          },
          {
            uid: "studentClass",
            name: "Class"
          },
          {
            uid: "admissionNo",
            name: "Admission No"
          },
          {
            uid: "onwardPickup",
            name: "Pickup Time",
            type: "Time"
          },
          {
            uid: "onwardDrop",
            name: "Drop Time",
            type: "Time"
          },
          {
            uid: "entryTime",
            name: "Entry Time",
            type: "Time"
          },
          {
            uid: "exitTime",
            name: "Exit Time",
            type: "Time"
          },
          {
            uid: "returnPickup",
            name: "Return Pickup",
            type: "Time"
          },
          {
            uid: "returnDrop",
            name: "Return Drop",
            type: "Time"
          }
        ],
        activeColumns: [
          "institutionName",
          "vehicleName",
          "regNo",
          "validUpto",
          "documentNumber",
          "status",
          "updatedDtString"
        ],
        innerFilters: [
          {
            uid: "inconsistencyType",
            label: "Inconsistency Type",
            type: "multiSelect",
            options: [
              {id: 1, name: "Boarded Bus - Not Deboarded at School"},
              {id: 2, name: "Deboarded at School - No School Entry"},
              {id: 3, name: "Entered School - No Morning Bus Record"},
              {id: 5, name: "Entered School - No School Exit"},
              {id: 6, name: "Exited School - Not Boarded Evening Bus"},
              {id: 7, name: "Boarded Evening Bus - Not Deboarded"}
              // {
              //   id: 4,
              //   name: "Morning Boarding - Evening Deboarding Count Mismatch"
              // }
            ],
            defaultValue: [1, 2, 3, 5, 6, 7]
          }
        ]
      },
      {
        icon: "",
        menu: "Fuel Filling & Theft",
        menu_description: "",
        url: "api/fuel/detailView",
        method: "POST",
        filters: ["date"],
        columns: [
          {
            uid: "vehicleName",
            name: "Vehicle Name"
          },
          // {
          //   uid: "regNo",
          //   name: "Reg No"
          // },
          {
            uid: "driverName",
            name: "Driver Name"
          },
          {
            uid: "type",
            name: "Status"
          },
          {
            uid: "recentFillDate",
            name: "Refill Date & Time"
          },
          {
            uid: "filledLitres",
            name: "Fuel Quantity (L)"
          },
          // {
          //   uid: "lastRefillDate",
          //   name: "Last Refill Date & Time"
          // },
          // {
          //   uid: "lastRefillLitres",
          //   name: "Last Refill Quantity (L)"
          // },
          {
            uid: "currentFuelLevel",
            name: "Current Fuel Level (L)"
          },
          {
            uid: "theftDate",
            name: "Theft Detected On"
          },
          {
            uid: "stolenLitres",
            name: "Fuel Loss (L)"
          },
          {
            uid: "location",
            name: "Location"
          }
        ],
        activeColumns: [
          "vehicleName",
          "regNo",
          "driverName",
          "type",
          // "lastRefillDate",
          // "lastRefillLitres",
          "currentFuelLevel",
          "theftDate",
          "stolenLitres",
          "location",
          "recentFillDate",
          "filledLitres"
        ],
        tabColumns: {
          "": [
            "vehicleName",
            "driverName",
            "type",
            "recentFillDate",
            "filledLitres",
            "currentFuelLevel",
            "theftDate",
            "stolenLitres",
            "location"
          ],
          "1": [
            "vehicleName",
            "driverName",
            "type",
            "recentFillDate",
            "filledLitres",
            "currentFuelLevel",
            "location"
          ],
          "2": [
            "vehicleName",
            "driverName",
            "type",
            "currentFuelLevel",
            "location"
          ],
          "3": [
            "vehicleName",
            "driverName",
            "type",
            "currentFuelLevel",
            "theftDate",
            "stolenLitres",
            "location"
          ],
          "4": ["vehicleName", "driverName", "type", "location"]
        },
        tabView: [
          {
            label: "All",
            id: ""
          },
          {
            label: "Fuel Fill",
            id: 1
          },
          {
            label: "Low Fuel",
            id: 2
          },
          {
            label: "Fuel Theft",
            id: 3
          },
          {
            label: "No Data",
            id: 4
          }
        ]
      },
      {
        icon: "",
        menu: "Trip Failure",
        menu_description: "",
        url: "/api/tripFailure/detailView",
        method: "POST",
        filters: [],
        columns: [
          {
            uid: "vehicleName",
            name: "Vehicle Name"
          },
          {
            uid: "routeName",
            name: "Route Name"
          },
          {
            uid: "branch",
            name: "Branch"
          },
          {
            uid: "type",
            name: "Type"
          },
          {
            uid: "startTime",
            name: "Start Time",
            type: "Time"
          },
          {
            uid: "endTime",
            name: "End Time",
            type: "Time"
          },
          {
            uid: "actualUsers",
            name: "Actual User"
          },
          {
            uid: "reason",
            name: "Reason"
          }
        ],
        activeColumns: [
          "vehicleName",
          "routeName",
          "branch",
          "type",
          "startTime",
          "endTime",
          "actualUsers",
          "reason"
        ],
        innerFilters: [
          {
            uid: "type",
            label: "Trip Failure Type",
            type: "multiSelect",
            options: [
              {id: 1, name: "Vehicle Didn't Operate"},
              {id: 2, name: "Vehicle Issue / Breakdown"},
              {id: 3, name: "Operated on Wrong Route"},
              {id: 4, name: "Vehicle Offline"}
            ],
            defaultValue: [1, 2, 3, 4]
          }
        ]
      },
      {
        icon: "",
        menu: "Driver Compliance Summary",
        menu_description: "",
        url: "api/driver/compliance/detail",
        method: "POST",
        filters: ["date"],
        columns: [
          {
            uid: "driver",
            name: "DRIVER",
            type: "String"
          },
          {
            uid: "empId",
            name: "EMP ID",
            type: "String"
          },
          {
            uid: "upToDate",
            name: "UP TO DATE",
            type: "ComplianceGroup",
            statusValue: 1
          },
          {
            uid: "expired",
            name: "EXPIRED",
            type: "ComplianceGroup",
            statusValue: 2
          },
          {
            uid: "nearExpiration",
            name: "NEAR EXPIRATION",
            type: "ComplianceGroup",
            statusValue: 4
          },
          {
            uid: "noData",
            name: "NO DATA",
            type: "ComplianceGroup",
            statusValue: 3
          }
        ],
        activeColumns: [
          "driver",
          "empId",
          "upToDate",
          "expired",
          "nearExpiration",
          "noData"
        ]
        // innerFilters: [
        //   {
        //     uid: "type",
        //     label: "Compliance Type",
        //     type: "multiSelect",
        //     options: [
        //       {id: 1, name: "Licence"},
        //       {id: 2, name: "Badge"},
        //       {id: 3, name: "Medical Test"},
        //       {id: 4, name: "PVC"},
        //       {id: 5, name: "DDT"},
        //       {id: 6, name: "BGV"}
        //     ],
        //     defaultValue: [1, 2, 3, 4, 5, 6]
        //   }
        // ]
      },
      {
        icon: "",
        menu: "Safety Risk Summary",
        menu_description:
          "Highlights unsafe driving events such as, over-speeding, sudden acceleration and harsh braking during trips and Helps improve driver safety, reduce risks, and ensure a safer journey for passengers.",
        url: "/api/reports/safetyRisk",
        method: "POST",
        filters: ["date"],
        columns: [
          {
            uid: "time",
            name: "TIME",
            type: "Datetime"
          },
          {
            uid: "vehicleName",
            name: "BUS",
            type: "String"
          },
          {
            uid: "driverName",
            name: "DRIVER",
            type: "String"
          },
          {
            uid: "eventType",
            name: "EVENT TYPE",
            type: "String"
          },
          {
            uid: "threshold",
            name: "RECORDED VALUE",
            type: "Number"
          },
          {
            uid: "location",
            name: "LOCATION",
            type: "Locations"
          }
        ],
        activeColumns: [
          "vehicleName",
          "driverName",
          "time",
          "eventType",
          "threshold",
          "location"
        ],
        innerFilters: [
          {
            uid: "alertTypes",
            label: "Event Type",
            type: "multiSelect",
            options: [
              {id: 5, name: "Sudden Acceleration"},
              {id: 6, name: "Harsh Breaking"},
              {id: 8, name: "Over Speeding"}
            ],
            defaultValue: [5, 6, 8]
          }
        ]
      },
      {
        icon: "",
        menu: "Visitor Summary",
        menu_description:
          "The Visitor Report is related to a system that monitors and tracks visitor entry, exit, and campus presence, including guardian visits, walk-in visitors, and pickup activities.",
        url: "/api/v2/staffApp/visitors/report",
        method: "POST",
        filters: ["date"],
        tableCardView: "visitorsReport",
        innerFilters: [
          {
            uid: "visitorType",
            label: "Visitor Type",
            type: "multiSelect",
            options: [
              {id: 1, name: "Guardian Visitors"},
              {id: 2, name: "Walk in Visitors"}
            ],
            defaultValue: [1, 2]
          }
        ],
        columns: [
          {
            uid: "visitorName",
            name: "VISITOR NAME",
            type: "String"
          },
          {
            uid: "visitorImage",
            name: "VISITOR IMAGE",
            type: "String"
          },
          {
            uid: "visitorPhoneNumber",
            name: "PHONE NUMBER",
            type: "Number"
          },
          {
            uid: "pickedupStudents",
            name: "PICKED UP STUDENTS",
            type: "Array"
          },
          {
            uid: "reason",
            name: "REASON",
            type: "String"
          },
          {
            uid: "checkInTime",
            name: "CHECK IN TIME",
            type: "Number"
          },
          {
            uid: "checkOutTime",
            name: "CHECK OUT TIME",
            type: "Number"
          }
        ],
        activeColumns: [
          "visitorName",
          "visitorImage",
          "visitorPhoneNumber",
          "pickedupStudents",
          "reason",
          "checkInTime",
          "checkOutTime"
        ]
      }
    ]
  }
];
